import React from "react";
import PropTypes from "prop-types";
import { User, Client } from "resourceModels";
import { getResource } from "selectors/resources";
import Button from "components/Common/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { activateTFA, checkTFA } from "actions";
import { fetchOne } from "actions/resources";

import InfoTooltip from "components/Common/InfoTooltip";
import { setSettingsSecurityState, removeTFA as removeTFAAction } from "./actions";
import "./style.scss";

class ModalProfileSecurity extends React.Component {
  constructor(props) {
    super(props);

    this.removeTFA = this.removeTFA.bind(this);
  }

  activateTFA() {
    const { user } = this.props;

    this.props.activateTFA(
      this.props.settingsSecurity.get("countryCode"),
      this.props.settingsSecurity.get("phoneNumber"),
      user.id
    );
  }

  changeInput(name, e) {
    const change = {};
    change[name] = e.target.value;
    this.props.setSettingsSecurityState(change);
  }

  checkTFA() {
    this.props.checkTFA(this.props.settingsSecurity.get("TFA"), false).then(() => {
      // re-fetch the user so the updated state (TFA enabled) is reflected on the frontend
      this.props.fetchOne("user");
    });
  }


  /**
   * checks if enforced MFA is enabled
   * if MFA is enabled show alert that says cannot be disabled
   * if MFA is not enabled confirm the want to disable and trigger removeTFA redux action
   */
  removeTFA() {
    const { client, user, removeTFA } = this.props;

    if (client.features.get("enforceMfa") && client.enforceMfa.get("enforced") && user.authyEnabled) {
      // eslint-disable-next-line no-alert
      window.confirm(
        "All members are required to have multi-factor authentication enabled. Contact your admin if you want to use a different phone number"
      );

      return;
    }

    // eslint-disable-next-line no-alert
    const removeTFAConfirmation = window.confirm(
      "Are you sure you would like to disable Two-Factor Authentication?"
    );

    if (removeTFAConfirmation) {
      removeTFA(user.id);
    }
  }

  handleBack() {
    this.props.setState("MODAL_PROFILE_SECURITY", {
      SMSSent: false
    });
  }

  render() {
    const {
      /** @type User */
      user
    } = this.props;

    let view;

    if (user.authyEnabled) {
      view = (
        <div className="ModalProfileSecurity__disable">
          <Button
            onClick={this.removeTFA}
            text="Disable"
            title="Disable"
            customClassName="ModalProfileSecurity__disable__button"
            light
            isLoading={this.props.settingsSecurity.get("disableTFALoading")}
          />
        </div>
      );
    } else {
      view = (
        <div className="ModalProfileSecurity__enable">
          {this.props.settingsSecurity.get("SMSSent") ? (
            <div className="ModalProfileSecurity__enable__validation">
              <div className="ModalProfileSecurity__enable__validation__container">
                <label
                  htmlFor="ModalProfileSecurity-authentication-code-input"
                  className="ModalProfileSecurity__enable__validation__container__label g-input__label"
                >
                  SMS
                </label>
                <input
                  id="ModalProfileSecurity-authentication-code-input"
                  className="ModalProfileSecurity__enable__validation__container__input g-input"
                  value={this.props.settingsSecurity.get("TFA")}
                  type="text"
                  placeholder="Authentication Code"
                  onChange={this.changeInput.bind(this, "TFA")}
                />
              </div>
              <Button
                onClick={() => this.checkTFA()}
                text="Activate"
                title="Activate"
                customClassName="ModalProfileSecurity__enable__validation__button"
                disabled={!this.props.settingsSecurity.get("TFA") || this.props.settingsSecurity.get("verifySMSLoading")}
                isLoading={this.props.settingsSecurity.get("verifySMSLoading")}
              />
              <Button
                onClick={() => this.handleBack()}
                text="Back"
                title="Back"
                customClassName="ModalProfileSecurity__enable__validation__button"
                light
              />
            </div>
          ) : (
            <div>
              <div className="ModalProfileSecurity__enable__inputs">
                <div className="ModalProfileSecurity__enable__inputs__container ModalProfileSecurity__enable__inputs__container--size-small">
                  <label
                    htmlFor="ModalProfileSecurity-country-code-input"
                    className="g-input__label ModalProfile__label"
                  >
                    Country Code
                  </label>
                  <input
                    id="ModalProfileSecurity-country-code-input"
                    className="ModalProfileSecurity__enable__inputs__container__input g-input"
                    value={this.props.settingsSecurity.get("countryCode")}
                    type="text"
                    placeholder="+1"
                    onChange={this.changeInput.bind(this, "countryCode")}
                  />
                </div>

                <div className="ModalProfileSecurity__enable__inputs__container">
                  <label
                    htmlFor="ModalProfileSecurity-phone-number-input"
                    className="g-input__label ModalProfile__label"
                  >
                    Phone Number
                  </label>
                  <input
                    id="ModalProfileSecurity-phone-number-input"
                    className="ModalProfileSecurity__enable__inputs__container__input g-input"
                    value={this.props.settingsSecurity.get("phoneNumber")}
                    type="tel"
                    placeholder="(123) 456-7890"
                    onChange={this.changeInput.bind(this, "phoneNumber")}
                  />
                </div>
                <Button
                  onClick={() => this.activateTFA()}
                  text="Request Activation Code"
                  title="Request Activation Code"
                  icon="Send"
                  customClassName="ModalProfileSecurity__enable__inputs__button"
                  disabled={!this.props.settingsSecurity.get("countryCode") || !this.props.settingsSecurity.get("phoneNumber") || this.props.settingsSecurity.get("requestSMSLoading")}
                  isLoading={this.props.settingsSecurity.get("requestSMSLoading")}
                />
              </div>
            </div>
          )}
        </div>
      );
    }

    return (
      <section className="ModalProfileSecurity Modal__section__sub-section">
        <h5 className="Modal__section__title ModalProfileSecurity__title">
          Two-Factor Authentication
          <InfoTooltip
            blurb="Adds an extra layer of protection by linking your account with your phone number. Whenever you sign in with your password, we'll send you a code via SMS."
            iconDefault="QuestionCircle"
            absolute
            inModal
          />
        </h5>
        {view}
      </section>
    );
  }
}

ModalProfileSecurity.propTypes = {
  client: PropTypes.instanceOf(Client).isRequired,
  fetchOne: PropTypes.func.isRequired,
  removeTFA: PropTypes.func.isRequired,
  user: PropTypes.instanceOf(User).isRequired
};

function mapState(state) {
  const { settingsSecurity } = state;

  return {
    client: getResource(state, "client"),
    settingsSecurity,
    user: getResource(state, "user")
  };
}

function mapDispatch(dispatch) {
  return {
    activateTFA: bindActionCreators(activateTFA, dispatch),
    checkTFA: bindActionCreators(checkTFA, dispatch),
    fetchOne: bindActionCreators(fetchOne, dispatch),
    setSettingsSecurityState: bindActionCreators(setSettingsSecurityState, dispatch),
    removeTFA: bindActionCreators(removeTFAAction, dispatch)
  };
}

const Connector = connect(mapState, mapDispatch)(ModalProfileSecurity);

export default Connector;
